import tripService from "../../../services/trip.service";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import Checkbox from "../../../shared/checkbox/checkbox";

const GroupFilters = ({filter, dispatcher}) => {
    const [groups, setGroups] = useState([]);
    const [searchedGroups, setSearchedGroups] = useState([]);
    const dispatch = useDispatch();

    const getGroups = async () => {
        const allVehicles = await tripService.getVehicles();
        const groupList = [];
        for (let vehicleObj of allVehicles.data.vehicles) {
            let isExist = true;
            for (let group of groupList) {
                if (vehicleObj?.group?.id === group?.id) {
                    isExist = false;
                }
            }
            if (isExist) {
                groupList.push(vehicleObj?.group);
            }
        }
        setGroups(groupList);
        setSearchedGroups(groupList);
    }
    const handleGroupSelect = (val) => {
        dispatch(dispatcher(val));
    }

    const handleSearch = (e) => {
        const searchTxt = (e.target.value).toLowerCase().trim();
        // reset on empty
        if (!searchTxt) {
            setSearchedGroups([...groups]);
        } else {
            const updatedGroups = groups.filter((group) =>
                (group?.name).toLowerCase().includes(searchTxt));
            setSearchedGroups(updatedGroups);
        }
    }

    useEffect(() => {
        getGroups();
    }, [])

    return(
        <>
            <div className="filter-title">Select Group</div>
            <div className="search-box margin-b-30 round-corner-8">
                <input type="text" placeholder={'Search'} onChange={handleSearch}/>
            </div>
            <ul className="filter-sec">
                {searchedGroups.map((group) =>
                    <li className={`page-fade-in`} key={group.id}>
                        <div className="filter-box"
                             onClick={event => handleGroupSelect(group?.id)}>
                            <Checkbox checked={filter?.groups.includes(group?.id)}/>
                            <div className={'filter-text'}>{(group.name).split('-').join(' ')}</div>
                        </div>
                    </li>
                )}
            </ul>
        </>
    )
}

export default GroupFilters;
